export default __webpack_public_path__ + "static/media/mc_1.0d9b773b.png";